import React, { useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import moment from 'moment';
import _ from 'lodash';
import { withStyles } from '@mui/styles';
import { getConnectorScoreHistory } from './ConnectorService';
import { PubSub } from '../../utils/eventUtils';

const GCPScoreHistory = ({
  classes,
  connectorType,
  connectorId,
  days,
  q,
}: any) => {
  const [myData, setMyData] = useState(null);
  const options = {
    chart: {
      type: 'line',
      height: '165px',
    },
    yAxis: {
      title: {
        text: '',
      },
      max: 100,
      lineColor: '#9192a4',
      lineWidth: 1,
      labels: {
        style: {
          color: '#c9cdd9',
        },
      },
    },
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
    },
    series: [],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    responsive: true,
  };

  const chartRef = useRef(null);

  useEffect(() => {
    const sub = PubSub.subscribe(
      'ConnectorDetails:toggleLines',
      (data: any) => {
        const { chart } = chartRef.current;
        const keys = Object.keys(data);
        keys.forEach((item, idx) => {
          chart.series[idx].setVisible(data[item]);
        });
      }
    );

    Promise.all([
      getConnectorScoreHistory({ connectorType, connectorId, days }),
    ])
      .then((responses) => {
        const scoresHistory = responses[0].data.histogram;
        setMyData({
          scoresHistory,
        });
      })
      .catch(console.error.bind(console));

    return () => {
      sub.remove();
    };
  }, [q.before, q.after, connectorType, connectorId, days]);

  const renderScoreHistorySection = () => {
    if (myData && myData.scoresHistory) {
      const { scoresHistory } = myData;
      const temp = {
        total: {
          name: '<span style="color: #fbc000;">Total Score</span>',
          data: [],
          color: '#fbc000',
        },
        identityTotal: {
          name: '<span style="color: #fa8072;">Identity</span>',
          data: [],
          color: '#fa8072',
        },
        networkTotal: {
          name: '<span style="color: #69a8e8;">Network</span>',
          data: [],
          color: '#69a8e8',
        },
        dataTotal: {
          name: '<span style="color: #cce30e;">Data</span>',
          data: [],
          color: '#cce30e',
        },
        infrastructureTotal: {
          name: '<span style="color: #fbc5bf;">Infrastructure</span>',
          data: [],
          color: '#fbc5bf',
        },
        encryptionTotal: {
          name: '<span style="color: #b4d4f5;">Encryption</span>',
          data: [],
          color: '#b4d4f5',
        },
      };

      scoresHistory.forEach((item: any) => {
        const { time } = item;

        _.forEach(item, (value, key) => {
          if (typeof value === 'object') {
            if (key === 'total') {
              if (value.value === null) {
                temp.total.data.push([
                  moment.utc(time).valueOf(),
                  temp.total.data[temp.total.data.length - 1][1],
                ]);
              } else {
                temp.total.data.push([moment.utc(time).valueOf(), value.value]);
              }
            }

            if (key === 'identityTotal') {
              if (value.value === null) {
                temp.identityTotal.data.push([
                  moment.utc(time).valueOf(),
                  temp.identityTotal.data[
                    temp.identityTotal.data.length - 1
                  ][1],
                ]);
              } else {
                temp.identityTotal.data.push([
                  moment.utc(time).valueOf(),

                  value.value,
                ]);
              }
            }

            if (key === 'networkTotal') {
              if (value.value === null) {
                temp.networkTotal.data.push([
                  moment.utc(time).valueOf(),
                  temp.networkTotal.data[temp.networkTotal.data.length - 1][1],
                ]);
              } else {
                temp.networkTotal.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }

            if (key === 'dataTotal') {
              if (value.value === null) {
                temp.dataTotal.data.push([
                  moment.utc(time).valueOf(),
                  temp.dataTotal.data[temp.dataTotal.data.length - 1][1],
                ]);
              } else {
                temp.dataTotal.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }

            if (key === 'infrastructureTotal') {
              if (value.value === null) {
                temp.infrastructureTotal.data.push([
                  moment.utc(time).valueOf(),
                  temp.infrastructureTotal.data[
                    temp.infrastructureTotal.data.length - 1
                  ][1],
                ]);
              } else {
                temp.infrastructureTotal.data.push([
                  moment.utc(time).valueOf(),

                  value.value,
                ]);
              }
            }

            if (key === 'encryptionTotal') {
              if (value.value === null) {
                temp.encryptionTotal.data.push([
                  moment.utc(time).valueOf(),
                  temp.encryptionTotal.data[
                    temp.encryptionTotal.data.length - 1
                  ][1],
                ]);
              } else {
                temp.encryptionTotal.data.push([
                  moment.utc(time).valueOf(),
                  value.value,
                ]);
              }
            }
          }
        });
      });
      options.series.push(temp.total);
      options.series.push(temp.identityTotal);
      options.series.push(temp.networkTotal);
      options.series.push(temp.dataTotal);
      options.series.push(temp.infrastructureTotal);
      options.series.push(temp.encryptionTotal);
      return (
        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
        />
      );
    }
    return (
      <img src="images/loading.svg" alt="" className={classes.loadingIcon} />
    );
  };

  if (myData) {
    return (
      <section className={classes.scoreHistoryContainer}>
        {renderScoreHistorySection()}
      </section>
    );
  }
  return null;
};

const styles = {
  chartsContainer: {
    width: '100%',
    height: '100%',
  },
  scoreHistoryContainer: {
    width: '100%',
    height: '100%',
    '& .highcharts-legend-item .highcharts-graph': {
      display: 'none',
    },
  },
};

export default withStyles(styles, { withTheme: true })(GCPScoreHistory);
